// extracted by mini-css-extract-plugin
export default {"WordlePlay":"WordlePlay_WordlePlay__ygMVH"};